module.exports = __webpack_public_path__ + "static/bannerMob-3c6adb9aec001852589ebbeffbaf402a.gif";